import React, { useState , useEffect ,useMemo} from "react";
import ticketicon from  "../../../../../../../../Assets/AppComponent/Customersupport_icon/ticketicon.svg"
import arroicon from  "../../../../../../../../Assets/AppComponent/Customersupport_icon/DetailArrow.svg"
import searchicon from "../../../../../../../../Assets/AppComponent/Customersupport_icon/Searchicon.svg"
import _ from "lodash";
import boximg from "../../../../../../../../Assets/AppComponent/Group 427320177.svg";
import { Innergeorecords } from "../Innergeorecords/Innergeorecords";



export default function Commonrecords({allIssues , title ,
  search, setSearch,
  Table_names
}) {

  const [openpopup , setPopup] = useState(false)
const [InnerData , setinnerdata] = useState("")


  const filteredIssues = allIssues.filter((issue) =>
    issue.name.toLowerCase().includes(search.toLowerCase())
  );

  function tochange(value) {
  debouncedSearch(value);  // call debounced search
}

const debouncedSearch = useMemo(
  () =>
    _.debounce((val) => {
      setSearch(val);     // set actual search state after 500ms
    }, 500),
  []
);

// Cancel debounce on unmount
useEffect(() => {
  return () => {
    debouncedSearch.cancel();
  };
}, [debouncedSearch]);

function capitalizeEachWord(text) {
  if (!text || typeof text !== "string" || text.trim() === "") {
    return "--";
  }
  
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}



  return (
    <>
    <div className="all-issue-category-list">
    <div className="HeaderOfList">
          <h6 style={{ fontSize: 16,  }}>{title}</h6>

    <div className="search-container">
  <span className="search-icon">
    <img src={searchicon} alt="search" />
  </span>
  <input
    type="text"
  onChange={(e) => tochange(e.target.value)}
    placeholder="Search..."
    className="search-input"
  />
</div>

    </div>
      <div  className="Recordslisted" >
  {filteredIssues.length > 0 ? (
  filteredIssues.map((issue) => (
    <div key={issue.id} className="issue-card">
      <div className="issue-left">
        <div className="Innner_iocn">
          <div className="icon-box">
            <img src={ticketicon} />
          </div>
        </div>
        <div className="issue-text">
                    <div className="name">{capitalizeEachWord(issue.name)}</div>
          <div className="count">{issue.count} Tickets</div>
        </div>
      </div>
   {Table_names && (
      <div className="Details_icons"
      onClick={(e)=>{
        setinnerdata(issue);
        console.log(issue ,"sdoifu issue");
        
        setPopup(true);

      }}>
        <img src={arroicon} className="arrow" />
      </div>
      )}
    </div>
  ))
) : (
  <div className="Dusbinbacktabls">
    <div>
      <img src={boximg} />
      <p className="text-center">No Data Available</p>
    </div>
  </div>
)}

      </div>
    </div>


 {openpopup && (


    <Innergeorecords 
    
    Table_name={Table_names}
    innerdatas={InnerData}
    show={openpopup} setshow={setPopup}/>
          
    )}
    </>
  );
}
